import { jsxs as _, jsx as a, Fragment as l } from "react/jsx-runtime";
import { useRef as h, useState as v } from "react";
import { useOutsideAlerter as p } from "./hooks/useOutsideAlerter.js";
import './assets/base-dropdown-menu-hover.css';const w = "_sidebar_idnrw_1", s = {
  sidebar: w,
  "sidebar--title": "_sidebar--title_idnrw_17",
  "sidebar--action": "_sidebar--action_idnrw_18",
  "sidebar--products": "_sidebar--products_idnrw_29",
  "sidebar--products--container": "_sidebar--products--container_idnrw_33",
  "sidebar--products--container--product": "_sidebar--products--container--product_idnrw_39",
  "sidebar--products--container--product__underline": "_sidebar--products--container--product__underline_idnrw_44",
  "sidebar--products--container--product--header": "_sidebar--products--container--product--header_idnrw_54",
  "sidebar--products--container--product--content": "_sidebar--products--container--product--content_idnrw_61",
  "sidebar--nav": "_sidebar--nav_idnrw_66",
  "base-item-hover": "_base-item-hover_idnrw_66",
  "base-item-hover--content": "_base-item-hover--content_idnrw_75",
  "base-item-hover--menu": "_base-item-hover--menu_idnrw_78",
  "base-item-hover--menu__hover": "_base-item-hover--menu__hover_idnrw_84",
  "sidebar--nav--option--chevron": "_sidebar--nav--option--chevron_idnrw_88",
  "base-item-hover--menu__right": "_base-item-hover--menu__right_idnrw_92",
  "base-item-hover--menu__top": "_base-item-hover--menu__top_idnrw_96",
  "base-item-hover--menu__left": "_base-item-hover--menu__left_idnrw_99",
  "base-item-hover--menu__bottom": "_base-item-hover--menu__bottom_idnrw_102",
  "sidebar--nav--option": "_sidebar--nav--option_idnrw_88",
  "sidebar--nav--option--menu": "_sidebar--nav--option--menu_idnrw_114",
  "sidebar--nav--option--menu--option": "_sidebar--nav--option--menu--option_idnrw_118",
  "open-sidebar": "_open-sidebar_idnrw_155",
  "close-sidebar": "_close-sidebar_idnrw_171"
};
function $(e) {
  const t = h(null), [o, r] = v(!1), n = e.menuContainerProps || null, i = e.onlyOpenOnClick, d = { ...e };
  delete d.menuContainerProps, delete d.onlyOpenOnClick;
  const c = (m) => {
    e.onClick && e.onClick(m), i && r((u) => !u);
  };
  return p({
    close: () => {
      r(!1);
    },
    isOpen: o,
    ref: t
  }), /* @__PURE__ */ _(
    "div",
    {
      ref: t,
      ...d,
      onClick: c,
      className: `${s["base-item-hover"]}${e.className ? " " + e.className : ""} ${i ? "hover:b-cursor-pointer" : ""}`,
      children: [
        /* @__PURE__ */ a(
          "div",
          {
            className: `${s["base-item-hover--content"]} b-flex b-w-full b-h-full`,
            children: e.children
          }
        ),
        /* @__PURE__ */ a(
          "div",
          {
            ...n,
            className: `${s["base-item-hover--menu"]} ${i ? "" : s["base-item-hover--menu__hover"]} ${s[`base-item-hover--menu__${e.position || "right"}`]} ${n != null && n.className ? " " + (n == null ? void 0 : n.className) : ""} ${o ? "!b-block" : ""} `,
            children: e.menu
          }
        )
      ]
    }
  );
}
function b({
  children: e,
  containerProps: t,
  bold: o = !1
}) {
  return /* @__PURE__ */ a(
    "li",
    {
      className: `hover:b-bg-gray-200 hover:b-cursor-pointer b-w-full b-p-0 b-m-0 b-py-1 b-bg-white b-text-black b-list-none ${o ? "b-font-bold" : "b-font-normal"} b-text-sm`,
      ...t,
      children: e
    }
  );
}
function N({
  options: e,
  containerProps: t,
  actions: o
}) {
  return /* @__PURE__ */ _(
    "menu",
    {
      className: "b-p-0 b-m-0 b-w-56 b-rounded b-bg-white b-shadow-lg b-overflow-hidden",
      ...t,
      children: [
        e.map(({ id: r, children: n, containerProps: i }) => /* @__PURE__ */ a(
          b,
          {
            id: r,
            containerProps: i,
            children: n
          },
          r
        )),
        o && /* @__PURE__ */ _(l, { children: [
          /* @__PURE__ */ a("hr", { className: "b-bg-gray-500 b-border-none b-h-[1px] b-m-0" }),
          " ",
          o.map(({ id: r, children: n, containerProps: i }) => /* @__PURE__ */ a(
            b,
            {
              id: r,
              containerProps: i,
              bold: !0,
              children: n
            },
            r
          ))
        ] })
      ]
    }
  );
}
export {
  $ as B,
  b as a,
  N as b,
  s
};
